import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 15h16","key":"svg-0"}],["path",{"d":"M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4","key":"svg-1"}],["path",{"d":"M4 20h12","key":"svg-2"}]]

const IconTextCaption = createReactComponent('outline', 'text-caption', 'TextCaption', __iconNode);

export default IconTextCaption;